<div class="row margin-top-20">
  <div class="col-lg-4 margin-bottom-30">
    <h3 class="bluelabel margin-bottom-0 margin-top-10">My Contacts</h3>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <ul class="switchingproperty">
      <li [class.active]="currentTab == tabs.PortfolioContacts" (click)="onTabClick(tabs.PortfolioContacts)">
        <a href="javascript:void(0);">
          Portfolio Contacts
        </a>
      </li>
      <li [class.active]="currentTab == tabs.PropertyContacts" (click)="onTabClick(tabs.PropertyContacts)">
        <a href="javascript:void(0);">
          Property Specific Contacts
        </a>
      </li>
    </ul>
    <div class="min-heightcontainer" *ngIf="currentTab == tabs.PortfolioContacts">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div class="margin-bottom-40">
            <app-portfolio-contact [UserGuid]="UserGuid"></app-portfolio-contact>
          </div>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
    <div *ngIf="currentTab == tabs.PropertyContacts">
      <ng-container>
        <div class="row">
          <div class="floatinghead clearfix">
          </div>
        </div>
        <div class="clearfix"></div>
        <ng-container>
          <div class="margin-bottom-40">
            <app-property-contact [UserGuid]="UserGuid"></app-property-contact>
          </div>
        </ng-container>
      </ng-container>
      <div class="clearfix"></div>
    </div>
  </div>
</div>

